import get from 'lodash/get';
import { productWithId, getOrderLineItemQuantityDiff } from './selectors';
import { variantWithSku } from 'common/selectors';
import { getAnalytics } from '../../common/analytics';
import * as c from './appConstants';

const itemProperties = (lineItem, state) => {
  const spreeVariant = variantWithSku(lineItem.sku, state);
  if (spreeVariant === null) return null;
  const options = lineItem.options || [];
  const flavorOption = options.find(option => option.type_name === 'flavor');
  const variant = get(flavorOption, 'value_presentation');
  const product = productWithId(spreeVariant.product_id, state);
  return {
    product_id: product.id.toString(),
    sku: lineItem.sku,
    name: product.name,
    variant,
    price: parseFloat(spreeVariant.price),
    quantity: lineItem.quantity,
    image_url: spreeVariant.image_url,
  };
};

export const cartContentsChanged = (orderPrev, orderNew, state) => {
  getOrderLineItemQuantityDiff(orderPrev, orderNew, state).forEach(
    ({ quantityDiff, lineItemNew }) => {
      let eventName;
      if (quantityDiff === 0) {
        return;
      } else if (quantityDiff > 0) {
        eventName = c.PRODUCT_ADDED;
      } else {
        eventName = c.PRODUCT_REMOVED;
      }
      const properties = itemProperties(lineItemNew, state);
      // If we can't find the item, then we need to bail. This can happen in the
      // case that a user has a stale item in their cart.
      if (properties === null) return;
      properties.quantity = Math.abs(quantityDiff);
      properties.path = window.location.pathname;
      properties.products = orderNew.line_items.map(lineItem =>
        itemProperties(lineItem, state)
      );
      getAnalytics().track(eventName, properties);
    }
  );
};

export const orderMembershipStatusChanged = (
  isMembershipOrder,
  eventLocation
) => {
  const eventName = isMembershipOrder
    ? c.AUTO_SHIP_ENABLED
    : c.AUTO_SHIP_DISABLED;

  getAnalytics().track(eventName, {
    eventLocation,
  });
};

export const quickShopModalVisibilityChanged = (isOpen, variants, state) => {
  const interaction = isOpen
    ? c.OPEN_QUICK_SHOP_MODAL
    : c.CLOSE_QUICK_SHOP_MODAL;
  const flavor = variants
    ? variants[0].flavor
    : state.selectedQuickShopVariant.flavor;

  getAnalytics().track(c.QUICK_SHOP_INTERACTION, {
    interaction,
    flavor,
  });
};

export const quickShopVariantChanged = (newVariant, state) => {
  const previousVariant = state.selectedQuickShopVariant;
  let interaction;

  if (!previousVariant) {
    // don't send an event on page load
    // does not represent a user action
    return;
  }

  if (newVariant.nicotinePercent !== previousVariant.nicotinePercent) {
    interaction = `${c.NICOTINE_STRENGTH} - ${newVariant.nicotinePercent}%`;
  } else if (newVariant.podCount !== previousVariant.podCount) {
    interaction = `${c.POD_PACK_SIZE} - ${newVariant.podCount}`;
  }

  getAnalytics().track(c.QUICK_SHOP_INTERACTION, {
    interaction,
    flavor: newVariant.flavor,
  });
};
